__turbopack_context__.v({
  "className": "audiowide_59c21041-module__Tbz7oq__className",
  "variable": "audiowide_59c21041-module__Tbz7oq__variable",
});
